<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">How XigCheck Works</h1>

        <section class="content-section">
            <p class="desc-text">XigCheck combines technology-assisted review workflows with independent authentication expertise to support marketplace trust and product review support for selected high-value categories.</p>
            <p class="desc-text">Authentication review procedures may include the following layers:</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">AI-Assisted Review</h2>
            <p class="desc-text">XigCheck may utilize technology-assisted analysis tools to help evaluate product details, image consistency, brand characteristics, serial patterns, and marketplace risk indicators.</p>
            <p class="desc-text">These systems are designed to support operational review efficiency and identify potential inconsistencies requiring additional verification.</p>
            <p class="desc-text">AI-assisted tools do not independently determine authentication outcomes and are used only as supporting review infrastructure.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">Expert-Assisted Review</h2>
            <p class="desc-text">Selected products may undergo manual review by trained authentication specialists experienced in luxury and collectible product categories.</p>
            <p class="desc-text">Expert review may involve:</p>
            <ul class="policy-list">
                <li>product detail analysis</li>
                <li>material and stitching review</li>
                <li>serial number evaluation</li>
                <li>logo and hardware comparison</li>
                <li>manufacturing characteristic review</li>
                <li>category-specific inspection procedures</li>
            </ul>
            <p class="desc-text">Review outcomes represent independent assessment opinions based on the information available at the time of assessment.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">Third-Party review support</h2>
            <p class="desc-text">Certain authentication reviews may be supported by independent third-party authentication service providers operating under separate service-level agreements.</p>
            <p class="desc-text">These providers may assist with:</p>
            <ul class="policy-list">
                <li>luxury brand authentication</li>
                <li>sneaker authentication</li>
                <li>collectible fashion authentication review</li>
                <li>supporting documentation review</li>
            </ul>
            <p class="desc-text">Third-party providers operate independently and do not provide financial guarantees, escrow services, or payment protection services.</p>
            <p class="desc-text">Authentication services are intended solely to support marketplace trust, transparency, and fraud prevention procedures.</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckHowItWorks'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
